module.exports = __webpack_public_path__ + "img/getstarted_artwork@3x.5bfac759.png";